"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.startHistogramTimer = exports.observeTiming = exports.observeHistogram = exports.increaseCounter = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));
var _types = require("./types");
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var increaseCounter = exports.increaseCounter = function increaseCounter(metricName) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var labels = arguments.length > 2 ? arguments[2] : undefined;
  return {
    metricName: metricName,
    metricType: _types.MetricType.COUNTER,
    labelsValues: labels,
    value: value
  };
};
var observeHistogram = exports.observeHistogram = function observeHistogram(metricName, value, labels) {
  return {
    metricName: metricName,
    metricType: _types.MetricType.HISTOGRAM,
    labelsValues: labels,
    value: value
  };
};
var observeTiming = exports.observeTiming = function observeTiming(metricName, value, labels) {
  return {
    metricName: metricName,
    metricType: _types.MetricType.TIMING,
    labelsValues: labels,
    value: value
  };
};
var startHistogramTimer = exports.startHistogramTimer = function startHistogramTimer(metricName) {
  var startLabels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var startDate = (0, _now.default)();
  return function () {
    var endLabels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var delta = (0, _now.default)() - startDate;
    var value = Number((delta / 1000).toFixed(2));
    return observeTiming(metricName, value, _objectSpread(_objectSpread({}, startLabels), endLabels));
  };
};
//# sourceMappingURL=metrics.js.map